/**
 * WidgetStudioTabs — the studio's top-level tab bar, shared by the widget
 * catalog (Standard Widgets / Templates) and the preset galleries (Landing
 * Presets / Cover Presets). One source of truth so all four tabs stay in sync.
 *
 * `active` is the tab id: 'standard' | 'template' | 'landing-presets' | 'cover-presets'.
 * `colors` supplies { accent, text, bgCard, border } so this matches the host palette.
 */
import { useNavigate } from 'react-router-dom';

const TABS = [
  { id: 'standard', label: 'Standard Widgets' },
  { id: 'template', label: 'Templates' },
  { id: 'landing-presets', label: 'Landing Presets' },
  { id: 'cover-presets', label: 'Cover Presets' },
];

export default function WidgetStudioTabs({ active, colors }) {
  const navigate = useNavigate();
  const c = colors || { accent: '#6E59F2', text: '#1c1c1e', bgCard: '#fff', border: '#e2e2ea' };
  return (
    <div style={{ display: 'inline-flex', borderRadius: 8, background: c.bgCard, border: `1px solid ${c.border}`, padding: 3 }}>
      {TABS.map((t) => {
        const on = t.id === active;
        return (
          <button
            key={t.id}
            onClick={() => navigate(`/playground/widget/studio/${t.id}`)}
            style={{
              background: on ? c.accent : 'transparent',
              color: on ? '#fff' : c.text,
              border: 'none', borderRadius: 6,
              padding: '8px 14px', fontSize: 13, fontWeight: 600,
              letterSpacing: '-0.01em', cursor: 'pointer', whiteSpace: 'nowrap',
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
